import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {inject} from '@angular/core';
import {catchError} from 'rxjs/operators';
import {EMPTY, Observable, of} from 'rxjs';
import {HostApi} from '@domain/host/host.api';
import {HostDTO, HostStats} from '@domain/host/host.dto';
import {StringUtil} from '@shared/util/string.util';


export class HostResolver {

  public static get: ResolveFn<HostDTO | null> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<HostDTO | null> => {
    const hostApi = inject(HostApi);
    const hostId = this.resolveHostId(route);
    if (!hostId) {
      return of(null);
    }
    return hostApi.get(hostId).pipe(
      catchError(err => {
        if (err.status === 404) {
          // Redirect to not-found or another page
          return of(null);
        }
        // Return EMPTY to cancel current navigation
        return EMPTY;
      })
    );
  };

  public static resolveHostId(route: ActivatedRouteSnapshot): string | null {
    let hostId = route.paramMap.get('hostId');
    if (!hostId) {
      hostId = StringUtil.resolveSlug(route.paramMap.get('slug'));
    }
    return hostId ?? null;
  };

  public static getStats: ResolveFn<HostStats> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<HostStats> => {
    const hostApi = inject(HostApi);
    return hostApi.getStats();
  };

}
